import { Markdown } from 'common/markdown-components';
import styles from './styles.module.css';

const markdownContent = `
# Scam Casino List

Short Description

These are casinos that have refused to pay, blocked accounts with active balances, or used other shady tactics. Avoid these sites at all costs.

Full Description

On this page, you'll find a list of online casinos that have shown dishonest or unethical behavior. Whether it's through stalled withdrawals, unjustified bans, or manipulating bonuses, these sites have proven untrustworthy. Our community and review team actively report and update this list to protect future players.

If you encounter a suspicious casino, report it so we can investigate and, if necessary, blacklist it.

## How a Casino Gets Blacklisted
![Uploaded Image](https://d11o05pl2tdcd2.cloudfront.net/blog-images/1746197128165-860432851-1.webp_resize_fullx400)


Casinos end up on our blacklist after:

	•	Repeated complaints about payment delays

	•	Banning players without cause or after a win

	•	Changing bonus terms retroactively

	•	Using pirated or fake games

	•	Operating without a valid license

	•	Ignoring attempts to resolve disputes

We conduct our own reviews, consider user-submitted complaints, and verify claims before adding any casino to the list.

## Signs of a Scam Casino
![Uploaded Image](https://d11o05pl2tdcd2.cloudfront.net/blog-images/1746197157708-507775270-2.webp_resize_fullx400)

Red flags include:

	•	No or fake license

	•	Too-good-to-be-true bonuses

	•	Sudden changes in terms and conditions

	•	No KYC checks followed by account bans at withdrawal

	•	Non-functional customer support



## Can a Blacklisted Casino Be Removed?


Yes, but only in rare cases. A blacklisted casino must:

	•	Resolve all pending complaints

	•	Compensate affected players

	•	Show consistent fair behavior over time

	•	Submit to regular RTP and fairness checks

	•	Even then, removal from the blacklist is not guaranteed.



## What If You Were Scammed?

If you've been scammed by a casino:

	•	Gather screenshots, transaction history, and any communication

	•	Submit a complaint through our complaint form

	•	If the casino is already on our blacklist, we may pursue further action

## Rules for Blacklisting a Casino 
![Uploaded Image](https://d11o05pl2tdcd2.cloudfront.net/blog-images/1746197166795-502046860-3.webp_resize_fullx400)

	•	We only blacklist after verifying the facts.

	•	We allow casinos to respond to accusations.

	•	We require full documentation from the player.

	•	Casinos are reviewed by our editorial and compliance team.

	•	Not all complaints lead to blacklisting—only systemic issues.

	•	A casino must maintain ethical conduct to avoid or be removed from the list.`;

export const BlackListedCasinosDescription = () => {
  return (
    <div className={styles.container}>
      <Markdown data={markdownContent} />
    </div>
  );
};
